module.exports = __webpack_public_path__ + "assets/media/evening.8043f33c.mp3";